import Moment from 'moment';
import GlobalEvent from '@/common/Event';

// 타임스탬프 포맷
const timeFormat = 'YYYY-MM-DD HH:mm:ss';
function now() { return Moment().format(timeFormat); }

// 메타 데이터 모델
class Header {
  constructor({ code = -1, message = '알 수 없는 오류입니다.', requestTime = now(), responseTime = now()}) {
    this.code = code;
    this.message = message;
    this.requestTime = requestTime;
    this.responseTime = responseTime;
  }
}

// 응답 데이터 모델
class resData {
  constructor(data) {
    this.header = new Header(_.get(data, 'header', {}));
    this.result = _.get(data, 'result', {});
    this.meta = _.get(data, 'meta', {});
  }
}

class BaseCommModel {
  constructor(responseBody) {
        
    this.data = new resData(responseBody.data);
    this.status = responseBody.status;

    // base validation    
    switch(this.status || 404) {
      
      // 로그인 되지 않음
      case 401:
      GlobalEvent.$emit('loginException');
      return false;
      case 502:
        // 웹서버는 살아있으나 스프링에 해당 모듈이 없음
      case 200:
      case 201:
      case 202:
      case 203:
      default:
        return true;
    }

    if(!_.has(responseBody, 'result')) {
      this.result = false;
      this.data = {
        msg: '알 수 없는 에러입니다.'
      };
      return false;
    }
    this.result = responseBody.result;

    this.valid = true;
    
    return responseBody.result;
  }

  get header() {
    return _.get(this, ['data', 'header'], {});
  }

  get body() {
    return _.get(this, ['data', 'result'], {});
  }

  get pagination() {
    return _.get(this, ['data', 'meta', 'pagination'], {});
  }
}

export default BaseCommModel;